const CELL_HEIGHT = 20;
const CELL_WIDTH = 8;

export const computeShellSize = (
  width: number,
  height: number,
): { cols: number; rows: number } => {
  const rows = Math.floor(height / CELL_HEIGHT);
  const cols = Math.floor(width / CELL_WIDTH);

  return {
    rows,
    cols,
  };
};
